module.exports = __webpack_public_path__ + "img/yszc-sj-yy.b56348af.png";